'use client';

import { Accordion, AccordionItem } from '@szhsin/react-accordion';
import { highlight, languages } from 'prismjs';
import React from 'react';
import Editor from 'react-simple-code-editor';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/themes/prism.css'; // Example style, you can use another

import { ChatMsgDebug } from '@/types/chat';

import styles from './traceStepsData.module.scss';


type Props = {
  agentStack: ChatMsgDebug[];
};

export default function TraceStepsData( props: Props ) {
  const { agentStack } = props;

  return (
    <div className={ styles.accordion_wrapper }>
      <Accordion>
        {
          agentStack.map( ( item, index ) => (
            <AccordionItem
              buttonProps={ { className: `${ styles.trace_button }` } }
              header={ 'step: ' + item.step }
              key={ index }
            >
              <div className={ styles.traceBox }>
                <div className={ styles.dataBox }>
                  <p className={ styles.dataBox_title }>Inputs</p>
                  <Editor
                    value={ JSON.stringify( item.inputs, null, 2 ) }
                    highlight={ code => highlight( code, languages.js, 'js' ) }
                    onValueChange={ () => {} }
                    padding={ 10 }
                    style={ {
                      fontFamily: '"Fira code", "Fira Mono", monospace',
                      fontSize: 12,
                      backgroundColor: '#efefef',
                      borderRadius: '5px'
                    } }
                  />
                </div>
                <div className={ styles.dataBox }>
                  <p className={ styles.dataBox_title }>Outputs</p>
                  <Editor
                    className={ styles.dataBox_editor }
                    value={ JSON.stringify( item.outputs, null, 2 ) }
                    highlight={ code => highlight( code, languages.js, 'js' ) }
                    onValueChange={ ()=>{} }
                    padding={ 10 }
                  />
                </div>
              </div>
            </AccordionItem>
          ) )
        }
      </Accordion>
    </div>
  );
}